<template>
  <div>
    <div class="d-flex justify-content-center align-items-center mb-2">
      <b-form-radio-group
        id="btn-radios-2"
        v-model="tipoChat"
        :options="tiposChats"
        buttons
        button-variant="primary"
        name="radio-btn-outline"
      />
    </div>
    <ul class="list-group">
      <li
        v-for="(chat,index) in chatsFiltro"
        :key="chat.id"
        :class="{'active':chat.id == chatAtual.id}"
        class="list-group-item d-flex justify-content-between align-items-center item-chats"
        @click="selecionarChat(index)"
      >
        <div class="d-flex w-100 justify-content-between align-items-center">
          <p class="mb-1">
            <img
              :src="chat.image ? chat.image : 'https://www.pena.com.br/wp-content/uploads/2017/05/user-icon.jpg'"
              class="img-avatar img-avatar-tamanho"
              onerror="this.onerror=null; this.src='https://www.pena.com.br/wp-content/uploads/2017/05/user-icon.jpg'"
            >
          </p>

          <p v-if="chat.titulo">
            {{ chat.titulo }}
          </p>

          <p v-else-if="!chat.titulo && chat.nome">
            {{ chat.nome }}
          </p>

          <span>
            <span class="mb-1 mr-1 badge badge-pill badge-secondary">
              {{ chat.tipo }}
            </span>

            <span
              v-if="chat.quantidadeMensagensNaoLidas"
              class="mb-1 badge badge-primary badge-pill"
            >
              {{ chat.quantidadeMensagensNaoLidas }}
            </span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable no-await-in-loop */
import { mapActions, mapGetters } from 'vuex';


export default {
  props: {
    chats: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tiposChats: ['All', 'Leads', 'Users', 'Groups'],
      tipoChat: 'All',
    };
  },
  created() {
    this.definirChatAtual(undefined);
  },
  computed: {
    ...mapGetters(['usuarioLogado', 'chatAtual']),
    chatsFiltro() {
      if (this.tipoChat === 'Leads') {
        return this.chats.filter((c) => c.tipo === 'LEAD');
      } if (this.tipoChat === 'Users') {
        return this.chats.filter((c) => c.tipo === 'USER');
      } if (this.tipoChat === 'Groups') {
        return this.chats.filter((c) => c.tipo === 'GROUP');
      }
      return this.chats;
    },
  },
  methods: {
    ...mapActions(['definirChatAtual']),
    async selecionarChat(index) {
      for (let i = 0; i < this.chats.length; i++) {
        const chat = this.chats[i];

        if (i === index && !chat.selecionado) {
          chat.selecionado = true;

          this.$emit('carregandoChatAtual', true);
          await this.definirChatAtual(chat);
          this.$emit('carregandoChatAtual', false);
        } else {
          chat.selecionado = false;
        }
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.item-chats {
  margin-right: 10px;
}
.item-chats.active {
  margin-right: 5px;
}
.img-avatar-tamanho {
  height: 50px;
  width: 50px;
}
li {
  cursor: pointer;
}
</style>
